
import { AdminTemplate, FTPFilesComponent } from "../../components";

export const FTPFiles = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "",
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true,
      }}
      showHeaderTitle={false}>
      <FTPFilesComponent />
    </AdminTemplate>
  );
};
